exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divBox[data-v-09dc519e]{padding:20px}.box-card .clearfix .selWidth[data-v-09dc519e]{width:200px}.box-card .clearfix .search-actions[data-v-09dc519e]{margin-top:10px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px}.pagination-container[data-v-09dc519e]{margin-top:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.pagination-container .el-pagination[data-v-09dc519e]{text-align:right}.mr10[data-v-09dc519e]{margin-right:10px}", ""]);

// exports
